// Etiquetas de las causas de baja del empleado.
//
// Debe mantenerse en sincronía con CAUSAS_FINIQUITO de
// erp_backend/Controllers/Nomina/finiquito.controllers.js y con el enum `causaFiniquito` de
// Models/Empleado.js y Models/Nomina/Finiquito.js — los tres son el mismo catálogo.
//
// Vivía dentro de Empleados.js; se sacó aquí cuando el historial de relación laboral necesitó las
// mismas etiquetas, para no tener dos copias que se puedan desincronizar.
export const CAUSA_FINIQUITO_LABEL = {
  renuncia: "Separación voluntaria",
  despido_justificado: "Despido justificado",
  despido_injustificado: "Despido injustificado",
  termino_contrato: "Término de contrato",
  muerte: "Muerte del trabajador",
  jubilacion: "Jubilación",
  cierre_empresa: "Cierre de la empresa",
};

/** La etiqueta de una causa, o el valor crudo si es una causa que no conocemos. */
export const etiquetaCausaFiniquito = (causa, vacio = "—") =>
  causa ? (CAUSA_FINIQUITO_LABEL[causa] || causa) : vacio;

export default CAUSA_FINIQUITO_LABEL;
